import { render, staticRenderFns } from "./ContentLoadingBlock.vue?vue&type=template&id=860fe9c4&"
import script from "./ContentLoadingBlock.vue?vue&type=script&lang=js&"
export * from "./ContentLoadingBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports